export enum ActionTypes {
  GET_RATTING_REQUEST = "@@rating/GET_RATTING_REQUEST",
  GET_RATTING_SUCCESS = "@@rating/GET_RATTING_SUCCESS",
  GET_RATTING_FAILURE = "@@rating/GET_RATTING_FAILURE",
 
  CREATE_RATTING_REQUEST = "@@rating/CREATE_RATTING_REQUEST",
  CREATE_RATTING_SUCCESS = "@@rating/CREATE_RATTING_SUCCESS",
  CREATE_RATTING_FAILURE = "@@rating/CREATE_RATTING_FAILURE",
}
